import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import TruncatedEllipsis from '../../truncated-ellipsis';
import EditorsManageWireCallout from '../../../editors-manage-wire/editors-manage-wire-callout';

const Header = styled.div`
  display: flex;
  
  & > .callout {
    display: inline;
    button {
      margin-top: 14px;
      z-index: 1;
    }
  }

  & > h2 {
    margin: ${props => (!props.isBelow480 && props.items === 1 ? '8px 24px 0 0' : '8px 0')};
    font-size: 19px;
    line-height: 130%;
    ${props => ((props.theme.isLarge && props.items === 1) || props.theme.isXLarge) && `
      font-size: 24px;
    `};
    ${props => !props.theme.isXLarge && !props.isBelow480 && props.items > 1 && `
      font-size: 17px;
    `};

    > a {
      color: ${props => props.theme.bodyColor};
      font-family: ${props => props.theme.fontFamilyHeader};
      font-weight: ${props => props.theme.fontWeightBold};
      &:hover {
        text-decoration: none;
      }
    }
  }
`;

export default function WireTitle({
  wire, items, showEditorManageTools, isBelow480, clickEventProps,
}) {
  const showEditorManageWire = showEditorManageTools && !isBelow480
    && (_.get(window, 'Livewire.currentUser.profile.canModifyWiresOfOthers') || wire.ownedByCurrentUser);

  const handleClick = () => {
    const { id, name, type } = clickEventProps;

    recordStatisticsEvent({
      event: name,
      statisticable: type,
      id,
      clicked_url: `/wires/${wire.slug}`,
      page: window.location.pathname,
    });

    return false;
  };

  return (
    <Header items={items} isBelow480={isBelow480}>
      {
        showEditorManageWire && (
          <EditorsManageWireCallout wire={
            {
              wire_id: wire.id,
              title: wire.title,
              editors_picked: wire.editorsPicked,
              published_at: wire.publishedAt,
              featured_count: wire.featuredCount,
              wire: {
                slug: wire.slug,
                user_id: wire.userId || 0,
                profile: {
                  profile_picture_url: _.get(wire, 'contributor.profilePicrtureUrl'),
                  name: _.get(wire, 'contributor.name'),
                  organisation: _.get(wire, 'contributor.organisation'),
                },
              },
            }
          }
          />
        )
      }
      <h2>
        <a href={`/wires/${wire.slug}`} onClick={handleClick}>
          <TruncatedEllipsis
            lines={4}
            summary={wire.title}
            useReadMore={false}
            hasTags={false}
          />
        </a>
      </h2>
    </Header>
  );
}

WireTitle.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    userId: PropTypes.number,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    ownedByCurrentUser: PropTypes.bool.isRequired,
    editorsPicked: PropTypes.bool.isRequired,
    featuredCount: PropTypes.number.isRequired,
    publishedAt: PropTypes.string.isRequired,
    contributor: PropTypes.shape({
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string.isRequired,
      organization: PropTypes.string,
    }),
  }).isRequired,
  showEditorManageTools: PropTypes.bool,
  items: PropTypes.number.isRequired,
  isBelow480: PropTypes.bool.isRequired,
  clickEventProps: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

WireTitle.defaultProps = {
  showEditorManageTools: true,
};
